export     function isFormValid(isImpulseForm , impulseFormData){
    if(!isImpulseForm) return true 
      const cityName = impulseFormData.cityName.trim();
      const isCityNameValid =
        cityName != "" && cityName != null && cityName != undefined;

      return isCityNameValid;
}